export const NAVIGATE_MESSAGE = 'e:notification:navigate';
export const GET_TOP_URL_MESSAGE = 'e:navigation:getTopUrl';
export const RECEIVE_TOP_URL_MESSAGE = 'e:navigation:receiveTopUrl';
